import { gql } from '@apollo/client';

export const EXPERIENCE_FRAGMENT = gql`
    fragment experienceFragment on Experience {
        _id
        enterprise {
            _id
            name
            logo
        }
        title
        description
        sector {
            _id
            sectorName
        }
        profession {
            _id
            professionName
        }
        type
        specialties {
            _id
            specialtyName
        }
        city
        country
        startDate
        endDate
        contactName
        contactNumber
        countryCode
        numberOfMonths
        current
    }
`;

export const EXPERIENCE_PUBLIC_FRAGMENT = gql`
    fragment experienceFragment on ExperiencePublic {
        _id
        enterprise {
            _id
            name
            logo
        }
        title
        description
        profession {
            _id
            professionName
        }
        type
        specialties {
            _id
            specialtyName
        }
        city
        country
        startDate
        endDate
    }
`;

export const ADD_EXPERIENCE_TALENT = gql`
    mutation addExperienceTalent($experienceInput: ExperienceInput, $talentId: ID) {
        addExperienceTalent(experienceInput: $experienceInput, talentId: $talentId) {
            ...experienceFragment
        }
    }
    ${EXPERIENCE_FRAGMENT}
`;

export const UPDATE_EXPERIENCE_TALENT = gql`
    mutation updateExperienceTalent($_id: ID!, $experienceInput: ExperienceInput, $talentId: ID) {
        updateExperienceTalent(_id: $_id, experienceInput: $experienceInput, talentId: $talentId) {
            ...experienceFragment
        }
    }
    ${EXPERIENCE_FRAGMENT}
`;

export const DELETE_EXPERIENCE_TALENT = gql`
    mutation deleteExperienceTalent($_id: ID!, $talentId: ID) {
        deleteExperienceTalent(_id: $_id, talentId: $talentId) {
            ...experienceFragment
        }
    }
    ${EXPERIENCE_FRAGMENT}
`;
